<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">International tax configurer</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <mat-dialog-content>
    <div class="inter_set">
        <div class="">
            <h3>Configure tax type</h3>
        </div>  
        <div class="row"> 
    <div class="col-sm-6" >
      <mat-form-field appearance="outline">
        <mat-label>Tax type</mat-label>
        <input matInput #input>
      </mat-form-field>
    </div>

    <div class="col-sm-6">
        <mat-form-field appearance="outline">
          <mat-label>Tax indentification number</mat-label>
          <input matInput #input>   
        </mat-form-field>
      </div>
    
    </div>
    <div class="add_newrt">
        <button mat-flat-button color="primary"> <mat-icon>add</mat-icon> Add tax type</button>
      </div>

<div class="">
    <h3>Configure tax value</h3>
</div>     
    <div class="row">
<div class="col-sm-6" >
  <mat-form-field appearance="outline">
    <mat-label>Tax name</mat-label>
    <input matInput #input>
  </mat-form-field>
</div>

<div class="col-sm-6">
    <mat-form-field appearance="outline">
      <mat-label>Tax percentage</mat-label>
      <input matInput #input>   
    </mat-form-field>
  </div>
</div>

<div class="row">
    <div class="col-sm-6" >
      <mat-form-field appearance="outline">
        <mat-label>Tax name</mat-label>
        <input matInput #input>
      </mat-form-field>
    </div>
    
    <div class="col-sm-6">
        <mat-form-field appearance="outline">
          <mat-label>Tax percentage</mat-label>
          <input matInput #input>   
        </mat-form-field>
      </div>
    </div>
    <div class="row">
        <div class="col-sm-6" >
          <mat-form-field appearance="outline">
            <mat-label>Tax name</mat-label>
            <input matInput #input>
          </mat-form-field>
        </div>
        
        <div class="col-sm-6">
            <mat-form-field appearance="outline">
              <mat-label>Tax percentage</mat-label>
              <input matInput #input>   
            </mat-form-field>
          </div>
        </div>

  <div class="add_newrt">
    <button mat-flat-button color="primary"> <mat-icon>add</mat-icon> Add tax value</button>
  </div>

</div>
  </mat-dialog-content>

  <mat-dialog-actions align="end" style="border-top: 1px solid #ddd;margin-top: 22px;">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="accent"> Save
    </button>
  </mat-dialog-actions>